import React, { useEffect, useRef } from 'react';
import styles from './aboutusSec.module.css';
import Marquee from 'react-fast-marquee';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const MarqueBig = () => {

    return (
        <div className={styles._marqueBig}>
            <div className={styles._marqueBig_inner}>
                <Marquee speed={200}>
                    <div className={styles._contentBig}>
                        <h3>We Magnify Growth</h3>
                    </div>
                </Marquee>
            </div>
        </div>
    );
};

export default MarqueBig;
